function createPost() {
    _signup.validate({
        messages: {
            firstname: {
                //required: i18n.t('labels.errors.required'),
                //letterswithbasicpunc: i18n.t('labels.errors.allowed_characters'),
            },
            lastname: {
                //required: i18n.t('labels.errors.required'),
                //letterswithbasicpunc: i18n.t('labels.errors.lastname.allowed_characters'),
            },
            password: {
                //required: i18n.t('labels.errors.required'),
                //minlength: $.validator.format(i18n.t('labels.errors.password_minlength')),
            },
            email: {
                //required: i18n.t('labels.errors.required'),
                //email: i18n.t('labels.errors.email_valid'),
                //emailNeverbounce: i18n.t('labels.errors.email_valid'),
            },
            birthday: {
                //required: i18n.t('labels.errors.required'),
            },
            gender: {
                //required: _gendertext,
            },
            country: {
                //required: i18n.t('labels.errors.required'),
            },
            homeevent: {
                //required: i18n.t('labels.errors.required'),
            },
            accept_terms: {
                required: _accepttext,
            },
        },
        rules: {
            email: {
                required: true,
                email: true,
                //emailNeverbounce: true,
            },
            password: {
                required: true,
                minlength: 8,
                maxlength: 100
            },
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            /*birthday: {
                required: true,
                dateISO: true,
            },*/
            gender: {
                required: true,
            },
            country: {
                required: true,
            },
            homeevent: {
                required: true,
            },
            accept_terms: {
                required: true,
            }
        },
        submitHandler: function(form, event) {
            signup(form, event, this);
        }
    });

    var autotest = getUrlParam('autotest');
    var first = getUrlParam('first');
    var last = getUrlParam('last');
    var email = getUrlParam('e');
    var emailfull = getUrlParam('email');

    var _email = document.getElementById('email');
    if ( typeof(_email) != 'undefined' && _email != null ) {
        if ( email ) {
            _email.value = email;
            _signup.trigger('submit');
        }

        if ( emailfull ) {
            _email.value = emailfull;
        }
    }

    var fname = document.getElementById('firstname');
    if ( first && (typeof(fname) != 'undefined' && fname != null ) ) { fname.value = first; }

    var lname = document.getElementById('lastname');
    if ( last && (typeof(lname) != 'undefined' && lname != null ) ) { lname.value = last; }


    if(autotest) {
        $('#signup-form input#firstname').val('Jamie');
        $('#signup-form input#lastname').val('Martin');
        $('#signup-form input#password').val('');
        $('#signup-form input#email').val('@ultra.us');
        $('#signup-form input#confirmemail').val('@ultra.us');
        $('#signup-form select#birthyear').val('2010');
        $('#signup-form select#birthmonth').val('04');
        $('#signup-form select#birthday').val('24');
        $('#signup-form select#country').val('US');
        $('#signup-form select#homeevent-signup').val('miami');
        setTimeout(function() { $('#signup-form select#homeevent-signup').val('miami') }, 500);
        setTimeout(function() { $('#signup-form select#homeevent-signup').val('miami') }, 2500);
        $('#signup-form input.male').prop('checked', true);
        $('#signup-form input#accept_terms').prop('checked', true);
    }
    homeEvents();
}

function signup(form, event, validator) {
    let $form = $(form);
    $form.addClass('is-submitting');

    let form_data = Object.fromEntries(new FormData(form).entries());

    var sourceurl = document.location.hostname;
    var rcode = getUrlParam('rcode');
    if(rcode) {
        sourceurl = `${sourceurl}?rcode=${rcode}`;
    }

    let verifyRedirect = $form.data('redirect');

    let passport_data = {
        email: form_data.email,
        password: form_data.password,
        firstname: form_data.firstname,
        lastname: form_data.lastname,
        birthday: `${form_data.birthyear}-${form_data.birthmonth}-${form_data.birthday}`,
        gender: form_data.gender,
        country: form_data.country,
        homeevent: form_data.homeevent,
        lang: window.navigator.userLanguage || window.navigator.language,
        source: sourceurl,
    };


    passport.create(passport_data, $('#locale').val())
        .fail(function (jqXHR, textStatus, error) {
            $(document).trigger('rebuild');
            if (jqXHR.status == 400) {
                var responseJSON = jqXHR.responseJSON;

                if (responseJSON.errors) {
                    //let errors = {};
                    $.each(responseJSON.errors, (error_key, error) => {
                        //errors[error_key] = i18n.t(`labels.errors.${error_key}`);
                        //showResult(errors[error_key], 'error');
                        showResult(error, 'error');
                    });
                    validator.showErrors(responseJSON.errors);
                    if (responseJSON.errors.birthday) {
                        showResult(errors.birthday, 'error');
                        $('#birthmonth').addClass('error');
                        $('#birthday').addClass('error');
                        $('#birthyear').addClass('error');
                    }

                    if (responseJSON.errors.password) {
                        showResult(errors.password, 'error');
                        //$('#password').addClass('error');
                    }
                }
            }
            else if (jqXHR.status == 409) {
                showResult(errors.duplicateemail, 'error');
            }
            else {
                showResult(errors.create, 'error');
            }
        })
        .done(function (data, textStatus, jqXHR) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'passport-create',
            });
            scrollToTop();

            $('button.uppsignup')
                .addClass('working')
                .attr('disabled', 'disabled');

            showResult(_createdinfo, 'info');

            setTimeout(function () {
                _container.fadeTo(300, 0);
            }, 1000);

            setTimeout(function () {
                almost = almost.replace('$user_firstname', $('#firstname').val());
                almost = almost.replace('$user_email', $('#email').val());
                _container.html(almost);
                _container.fadeTo(300, 1);
            }, 1500);

            setTimeout(function () {
                scrollToTop();
                showResult(_createdsuccess, 'success', { duration: 11000 });
            }, 4000);

            setTimeout(function () {
                uppLogin(passport_data.email, passport_data.password)
                    .done(function () {
                        setTimeout(function () {
                            sendVerify(upp_page.verify, verifyRedirect);
                        }, 2000);

                        setTimeout(function () {
                            $('button.continue')
                                .removeClass('working')
                                .removeClass('disabled')
                                .removeClass('gray-btn')
                                .addClass('gold-btn')
                                .prop('disabled', false);
                        }, 5000);
                    });
            }, 5500);
        });
}

function sendVerify(url, redirect) {
    var locale = $('#locale').val();

    let urlObj = new URL(url);
    if(redirect !== undefined) {
        urlObj.searchParams.append('redirect', redirect);
    }

    showResult(_sendingverification, 'info');
    return passport.sendVerify(urlObj, locale)
    .fail(function(jqXHR, textStatus, error){
        //$(document).trigger('rebuild');
        /*if (jqXHR.status == 401) {
            //$(document).trigger('logged-out');
        } else if (jqXHR.status == 409) {
        } else {
        }*/
        showResult(errors.general, 'error');
  })
    .done(function(data, textStatus, jqXHR){
        showResult(_verifysent, 'success');
        //$(document).trigger('rebuild');
    })
}

function postProcessVerify() {
    _verify.on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {
            processVerify(form);
        }
    });
}

function processVerify() {

    var token = $('#token').val();
    var email = $('#verifyemail').val();
    var locale = $('#locale').val();

    return passport.processVerify(token, email, upp_page.events, locale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        switch (jqXHR.status) {
            case 409:
                showResult(errors.duplicateemail, 'error');
                break;
            case 422:
                showResult(errors.pnc, 'warning');
                var nc = jqXHR.responseJSON;
                var editParams = {
                    token: nc.token
                };
                var redirect = getUrlParam('redirect');
                if (redirect){
                    editParams.redirect = redirect;
                }
                var editurl = upp_page.edit + '?' + $.param(editParams);
                document.location.assign(editurl);
                break;
            case 401:
            case 404:
            default:
                showResult(errors.token, 'error');
        }
    })
    .done(function(data, textStatus, jqXHR){
        showResult(_accountverified, 'success');
        $(document).trigger('rebuild');

        setTimeout(function() {
            passportRedirect();
        }, 2000);
    })
}